import { render, staticRenderFns } from "./r-plinko-obstacle-config-dialog.vue?vue&type=template&id=6b64a641&scoped=true"
import script from "./r-plinko-obstacle-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-plinko-obstacle-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-plinko-obstacle-config-dialog.vue?vue&type=style&index=0&id=6b64a641&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64a641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b64a641')) {
      api.createRecord('6b64a641', component.options)
    } else {
      api.reload('6b64a641', component.options)
    }
    module.hot.accept("./r-plinko-obstacle-config-dialog.vue?vue&type=template&id=6b64a641&scoped=true", function () {
      api.rerender('6b64a641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-obstacle-config-dialog.vue"
export default component.exports